import DailyStatsCard from './DailyStatsCard';

export default DailyStatsCard;
